const ContificoCodeBadge = ({ code, className = '', compact = false }) => {
	const normalizedCode = typeof code === 'string' ? code.trim() : '';

	return (
		<div
			className={`d-flex flex-column ${className}`.trim()}
			style={{ maxWidth: '100%' }}
			title={normalizedCode || 'Codigo Contifico no registrado'}
		>
			<div
				className={`d-inline-flex align-items-center gap-2 rounded-pill border ${compact ? 'px-2 py-1' : 'px-3 py-1'}`}
				style={{
					backgroundColor: '#fff5f2',
					borderColor: 'rgba(181, 67, 15, 0.3)',
					width: 'fit-content',
					maxWidth: '100%',
				}}
			>
				<span
					className="fw-semibold text-uppercase"
					style={{
						color: '#b5430f',
						letterSpacing: '0.45px',
						fontSize: compact ? '0.62rem' : '0.68rem',
						flexShrink: 0,
					}}
				>
					Codigo Interno
				</span>
				<span
					className="fw-bold text-truncate"
					style={{
						color: '#7f2f0a',
						fontSize: compact ? '0.72rem' : '0.82rem',
						maxWidth: compact ? '170px' : '100%',
					}}
				>
					{normalizedCode || 'Sin codigo registrado'}
				</span>
			</div>
			{!compact && (
				<small className="text-muted mt-1" style={{ fontSize: '0.72rem' }}>
					Referencia interna de la empresa.
				</small>
			)}
		</div>
	);
};

export default ContificoCodeBadge;

